import { getStoryLastUpdatedDate } from "./getStoryLastUpdatedDate";
import { addTimeSeparatorToDate } from "./addTimeSeparatorToDate";

export { getStoryLastUpdatedDate, addTimeSeparatorToDate };
